import { CardBox as TimelineCardBox } from './style'
import TimelineTag from './Timeline'
import TimelineCardContent from './TimelineCardContent'
import TimelineItem from './TimelineItem'
const Timeline = {
  Timeline: TimelineTag,
  TimelineItem,
  TimelineCardContent,
  TimelineCardBox,
}
export { TimelineTag as Timeline, TimelineItem, TimelineCardContent, TimelineCardBox }
export default Timeline
